import React, { useState, useEffect, useRef } from "react";
import { Select, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getBrands,
  getPaneIndex,
  getUniqueBrandList,
  getWindowLocationPath,
} from "../../../../../redux/constants";
import isEqual from "react-fast-compare";
import {
  setBrandsInScreen,
  setClearAllScreenWidgetGraphData,
  setStreamScreenBrand,
  updateScreenWidgetPropdataWithClearGraphData,
} from "../../../../../redux/actions/commandCenter/screens/screen";
import Default_Brand from "../../../../../assets/brandLogos/Default_Brand.svg";
import Image from "antd/lib/image";

const SingleBrandsDropdown = ({
  section_index,
  widget_index,
  widgetData,
  template_widget,
  inStreamScreenWithFilter = false,
}) => {
  const { Option } = Select;
  const selectRef = useRef();
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const templateDetails = useSelector(
    (state) => state?.Section?.templateDetails
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const Section = useSelector((state) => state.Section.addSection);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const screenSettings = useSelector(
    (state) => state?.Screens?.screen?.settings
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const selectLogicalBrandValue = useSelector(
    (state) => state?.Logicalgroup.selectLogicalBrandValue
  ); // selected brand values

  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  useEffect(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    let selectedBrands = null;
    let sectionComprtitorBrandTypeExists = false;
    let sectionComprtitorBrandType = null;
    if (authParams?.screen_id === "000-000-557") {
      if (!screen?.stream_screen_brand) {
        let widget_metadata = screen?.widgets?.[widget_index];
        let defaultBrand = widget_metadata?.brand_ids
          ? widget_metadata?.brand_ids
          : [Allbrands?.[0]];
        dispatch(setStreamScreenBrand(defaultBrand));
      }
      selectedBrands = Allbrands;
    } else if (pathName === "CommandCenter"?.toLowerCase()) {
      // let global_brand =
      //   screen?.brands && screen?.brands?.columns?.length
      //     ? screen?.brands && screen?.brands?.columns
      //     : screen?.brands && screen?.brands?.length
      //     ? screen?.brands && screen?.brands
      //     : selectLogicalBrandValue?.["CommandCenter"]?.data?.columns?.length
      //     ? selectLogicalBrandValue?.["CommandCenter"]?.data?.columns
      //     : selectLogicalBrandValue?.["CommandCenter"]?.data?.length
      //     ? selectLogicalBrandValue?.["CommandCenter"]?.data
      //     : null;

      // let section =
      //   section_index !== null &&
      //   section_index !== undefined &&
      //   screen?.sections &&
      //   screen?.sections?.[section_index]
      //     ? screen?.sections?.[section_index]
      //     : section_index >= 0 &&
      //       screen?.sections &&
      //       screen?.sections?.[section_index]
      //     ? screen?.sections?.[section_index]
      //     : screen?.section && screen?.section?.[0]
      //     ? screen?.section?.[0]
      //     : null;
      // let secLockedOnBrand =
      //   (section?.is_locked &&
      //     section?.brands?.length > 0 &&
      //     (section?.brands?.[0]?.columns?.length > 0
      //       ? !section?.brands?.[0]?.columns?.[0]?.competitor
      //       : !section?.brands?.[0]?.competitor)) ||
      //   (section?.is_locked &&
      //     (section?.brand_groups?.length > 0 ||
      //       section?.brand_ids?.length > 0));
      // let comBrandtypeExists =
      //   section?.comp_brand_type === false || section?.comp_brand_type === true
      //     ? true
      //     : false;
      // sectionComprtitorBrandType =
      //   section?.comp_brand_type === false || section?.comp_brand_type === true
      //     ? section?.comp_brand_type
      //     : null;

      // let section_brands =
      //   section?.brand_ids?.length > 0 ? section?.brand_ids : null;
      // let section_logical_brands =
      //   section?.brand_groups?.length > 0 ? section?.brand_groups : null;

      // let finalBrand_list = getBrands(
      //   brandlogicalgroup,
      //   section_brands,
      //   Allbrands,
      //   section_logical_brands
      // );
      // console.log("finalBrand_list : ", finalBrand_list);
      // let sectionBrand =
      //   finalBrand_list?.columns?.length > 0 ? finalBrand_list?.columns : null;
      // sectionComprtitorBrandTypeExists =
      //   !secLockedOnBrand && comBrandtypeExists;

      // selectedBrands =
      //   secLockedOnBrand && !comBrandtypeExists ? sectionBrand : global_brand;
      selectedBrands = Allbrands;
    } else if (
      pathName === "edit-dashboard" ||
      pathName === "create-dashboard"
    ) {
      let global_brand = templateDetails?.templateBrands?.columns?.length
        ? templateDetails?.templateBrands?.columns
        : templateDetails?.templateBrands?.length
        ? templateDetails?.templateBrands
        : selectLogicalBrandValue?.["template_global"]?.data?.columns?.length
        ? selectLogicalBrandValue?.["template_global"]?.data?.columns
        : selectLogicalBrandValue?.["template_global"]?.data?.length
        ? selectLogicalBrandValue?.["template_global"]?.data
        : null;
      let sec = section_index >= 0 ? Section?.[section_index] : Section?.[0];
      let secLockedOnBrand =
        sec?.is_locked &&
        sec?.brands?.length > 0 &&
        (sec?.brands?.[0]?.columns?.length > 0
          ? !sec?.brands?.[0]?.columns?.[0]?.competitor
          : !sec?.brands?.[0]?.competitor);
      let comBrandtypeExists =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? true
          : false;
      sectionComprtitorBrandType =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? sec?.comp_brand_type
          : null;
      let sectionBrand =
        sec?.brands?.length > 0
          ? sec?.brands?.[0]?.columns?.length > 0
            ? sec?.brands?.[0]?.columns
            : !sec?.brands?.[0]
          : null;
      selectedBrands =
        secLockedOnBrand && !comBrandtypeExists ? sectionBrand : global_brand;
      sectionComprtitorBrandTypeExists =
        !secLockedOnBrand && comBrandtypeExists;
    } else if (shareTemplateData) {
      let sec =
        section_index >= 0 && shareTemplateData?.sections
          ? shareTemplateData?.sections?.[section_index]
          : shareTemplateData?.section?.[0];
      let secLockedOnBrand =
        (sec?.is_locked &&
          sec?.brands?.length > 0 &&
          (sec?.brands?.[0]?.columns?.length > 0
            ? !sec?.brands?.[0]?.columns?.[0]?.competitor
            : !sec?.brands?.[0]?.competitor)) ||
        (sec?.is_locked &&
          (sec?.brand_groups?.length > 0 || sec?.brand_ids?.length > 0));
      let comBrandtypeExists =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? true
          : false;
      sectionComprtitorBrandType =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? sec?.comp_brand_type
          : null;
      let share_section_brands =
        section_index >= 0
          ? shareTemplateData?.sections &&
            shareTemplateData?.sections[section_index] &&
            shareTemplateData?.sections[section_index]?.brand_ids
          : [null, undefined]?.includes(section_index) &&
            shareTemplateData?.sections &&
            shareTemplateData?.sections[0]
          ? shareTemplateData?.sections[0]?.brand_ids
          : null;
      let share_section_logical_brands =
        section_index >= 0
          ? shareTemplateData?.sections &&
            shareTemplateData?.sections[section_index] &&
            shareTemplateData?.sections[section_index]?.brand_groups
          : !section_index &&
            shareTemplateData?.sections &&
            shareTemplateData?.sections[0]
          ? shareTemplateData?.sections[0]?.brand_groups
          : null;
      let finalBrand_list = getBrands(
        shareBrands?.brand_groups,
        share_section_brands,
        shareBrands?.brand_list,
        share_section_logical_brands
      );
      let sectionBrand =
        finalBrand_list?.columns?.length > 0 ? finalBrand_list?.columns : null;
      selectedBrands =
        secLockedOnBrand && !comBrandtypeExists ? sectionBrand : null;
      sectionComprtitorBrandTypeExists =
        !secLockedOnBrand && comBrandtypeExists;
      if (!secLockedOnBrand && !comBrandtypeExists) {
        // Handle case where brands are stored in shareBrands?.brand (global dashboard format)
        if (shareBrands?.brands) {
          let selectedBrandsFromShare = shareBrands?.brands?.columns?.length
            ? shareBrands?.brands?.columns
            : shareBrands?.brands?.length
            ? shareBrands?.brands
            : null;

          if (selectedBrandsFromShare) {
            // Check if these are normal brands (not group or competitor)
            if (
              selectedBrandsFromShare &&
              !selectedBrandsFromShare?.[0]?.group &&
              !selectedBrandsFromShare?.[0]?.competitor
            ) {
              let brandList = [];
              if (
                Array.isArray(selectedBrandsFromShare) &&
                selectedBrandsFromShare?.length
              ) {
                brandList = selectedBrandsFromShare?.map((b) => {
                  b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
                  return b;
                });
                setBrandList([...brandList]);
              }
            } else if (
              selectedBrandsFromShare &&
              selectedBrandsFromShare?.[0]?.group
            ) {
              // for logical brand
              let filterBrandLogicalGroup = [];
              Array.isArray(selectedBrandsFromShare) &&
                selectedBrandsFromShare?.forEach((sB) => {
                  shareBrands?.brand_groups?.forEach((el) => {
                    if (
                      String(el?.brand_group_name)?.trim()?.toLowerCase() ===
                      String(sB?.brand_group_name)?.trim()?.toLowerCase()
                    ) {
                      filterBrandLogicalGroup = [
                        ...filterBrandLogicalGroup,
                        { ...el },
                      ];
                    }
                  });
                });
              let brandList = [];
              filterBrandLogicalGroup?.map((bl) => {
                brandList = Array.isArray(bl?.brand_list)
                  ? [...brandList, ...bl?.brand_list]
                  : [...brandList];
              });
              let uniqueBrandList = getUniqueBrandList(brandList);
              setBrandList([...uniqueBrandList]);
            } else if (
              selectedBrandsFromShare &&
              selectedBrandsFromShare?.[0]?.competitor
            ) {
              // for competitor brand
              let brandList = [];
              let newl = [];
              brandList.push({
                brand_id: selectedBrandsFromShare?.[0]?.brand_id
                  ? selectedBrandsFromShare?.[0]?.brand_id
                  : selectedBrandsFromShare?.[0]?.name,
                brand_name: selectedBrandsFromShare?.[0]?.brand_name,
                brand_friendly_name:
                  selectedBrandsFromShare?.[0]?.brand_friendly_name,
              });
              newl = selectedBrandsFromShare?.[0]?.competitorList;
              brandList = [...brandList, ...newl];
              let uniqueBrandList = getUniqueBrandList(brandList);
              setBrandList([...uniqueBrandList]);
            }
          }
        } else if (
          shareBrands?.selected_brand_ids?.length &&
          !shareBrands?.selected_comp_brand_ids?.length
        ) {
          let brandList = [];
          if (
            Array.isArray(shareBrands?.selected_brand_ids) &&
            shareBrands?.selected_brand_ids?.length
          ) {
            brandList = shareBrands?.selected_brand_ids?.map((b) => {
              b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
              return b;
            });
            setBrandList([...brandList]);
          }
        } else if (shareBrands?.selected_brand_groups?.length) {
          // for logical brand
          let filterBrandLogicalGroup = [];
          Array.isArray(shareBrands?.selected_brand_groups) &&
            shareBrands?.selected_brand_groups?.forEach((sB) => {
              shareBrands?.brand_groups?.forEach((el) => {
                if (
                  String(el?.brand_group_name)?.trim()?.toLowerCase() ===
                  String(sB?.brand_group_name)?.trim()?.toLowerCase()
                ) {
                  filterBrandLogicalGroup = [
                    ...filterBrandLogicalGroup,
                    { ...el },
                  ];
                }
              });
            });
          let brandList = [];
          filterBrandLogicalGroup?.map((bl) => {
            brandList = Array.isArray(bl?.brand_list)
              ? [...brandList, ...bl?.brand_list]
              : [...brandList];
          });
          let uniqueBrandList = getUniqueBrandList(brandList);
          setBrandList([...uniqueBrandList]);
        } else if (shareBrands?.selected_comp_brand_ids?.length) {
          let brandList = [];
          let com_brandList = [];
          if (
            Array.isArray(shareBrands?.selected_brand_ids) &&
            shareBrands?.selected_brand_ids?.length
          ) {
            brandList = shareBrands?.selected_brand_ids?.map((b) => {
              b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
              return b;
            });
          }
          if (
            Array.isArray(shareBrands?.selected_comp_brand_ids) &&
            shareBrands?.selected_comp_brand_ids?.length
          ) {
            com_brandList = shareBrands?.selected_comp_brand_ids?.map((b) => {
              b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
              return b;
            });
          }
          brandList = [...brandList, ...com_brandList];
          let uniqueBrandList = getUniqueBrandList(brandList);
          setBrandList([...uniqueBrandList]);
        }
      } else if (secLockedOnBrand || comBrandtypeExists) {
        if (
          selectedBrands &&
          !selectedBrands?.[0]?.group &&
          !selectedBrands?.[0]?.competitor
        ) {
          let brandList = [];
          if (Array.isArray(selectedBrands) && selectedBrands?.length) {
            brandList = selectedBrands?.map((b) => {
              b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
              return b;
            });
            setBrandList([...brandList]);
          }
        } else if (selectedBrands && selectedBrands?.[0]?.group) {
          // for logical brand
          let filterBrandLogicalGroup = [];
          Array.isArray(selectedBrands) &&
            selectedBrands?.forEach((sB) => {
              shareBrands?.brand_groups?.forEach((el) => {
                if (
                  String(el?.brand_group_name)?.trim()?.toLowerCase() ===
                  String(sB?.brand_group_name)?.trim()?.toLowerCase()
                ) {
                  filterBrandLogicalGroup = [
                    ...filterBrandLogicalGroup,
                    { ...el },
                  ];
                }
              });
            });
          let brandList = [];
          filterBrandLogicalGroup?.map((bl) => {
            brandList = Array.isArray(bl?.brand_list)
              ? [...brandList, ...bl?.brand_list]
              : [...brandList];
          });
          let uniqueBrandList = getUniqueBrandList(brandList);
          setBrandList([...uniqueBrandList]);
        } else if (shareBrands?.brands) {
          // for competitor brand
          let selectedBrandsFromShare = shareBrands?.brands?.columns?.length
            ? shareBrands?.brands?.columns
            : shareBrands?.brands?.length
            ? shareBrands?.brands
            : null;

          if (selectedBrandsFromShare) {
            // Check if these are normal brands (not group or competitor)
            if (
              selectedBrandsFromShare &&
              selectedBrandsFromShare?.[0]?.competitor
            ) {
              // for competitor brand
              let brandList = [];
              let newl = [];
              if (!sectionComprtitorBrandTypeExists) {
                brandList.push({
                  brand_id: selectedBrandsFromShare?.[0]?.brand_id
                    ? selectedBrandsFromShare?.[0]?.brand_id
                    : selectedBrandsFromShare?.[0]?.name,
                  brand_name: selectedBrandsFromShare?.[0]?.brand_name,
                  brand_friendly_name:
                    selectedBrandsFromShare?.[0]?.brand_friendly_name,
                });
                newl = selectedBrandsFromShare?.[0]?.competitorList;
                brandList = [...brandList, ...newl];
              } else if (sectionComprtitorBrandType === false) {
                brandList.push({
                  brand_id: selectedBrandsFromShare?.[0]?.brand_id
                    ? selectedBrandsFromShare?.[0]?.brand_id
                    : selectedBrandsFromShare?.[0]?.name,
                  brand_name: selectedBrandsFromShare?.[0]?.brand_name,
                  brand_friendly_name:
                    selectedBrandsFromShare?.[0]?.brand_friendly_name,
                });
              } else if (sectionComprtitorBrandType === true) {
                newl = selectedBrandsFromShare?.[0]?.competitorList;
                brandList = [...brandList, ...newl];
              }
              let uniqueBrandList = getUniqueBrandList(brandList);
              setBrandList([...uniqueBrandList]);
            }
          }
        } else if (shareBrands?.selected_comp_brand_ids?.length) {
          // for compititor brand
          let brandList = [];
          if (!sectionComprtitorBrandTypeExists) {
            if (
              Array.isArray(shareBrands?.selected_brand_ids) &&
              shareBrands?.selected_brand_ids?.length
            ) {
              brandList = shareBrands?.selected_brand_ids?.map((b) => {
                b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
                return b;
              });
            }
            if (
              Array.isArray(shareBrands?.selected_comp_brand_ids) &&
              shareBrands?.selected_comp_brand_ids?.length
            ) {
              let com_brandList = shareBrands?.selected_comp_brand_ids?.map(
                (b) => {
                  b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
                  return b;
                }
              );
              brandList = [...brandList, ...com_brandList];
            }
          } else if (sectionComprtitorBrandType === false) {
            if (
              Array.isArray(shareBrands?.selected_brand_ids) &&
              shareBrands?.selected_brand_ids?.length
            ) {
              brandList = shareBrands?.selected_brand_ids?.map((b) => {
                b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
                return b;
              });
            }
          } else if (sectionComprtitorBrandType === true) {
            if (
              Array.isArray(shareBrands?.selected_comp_brand_ids) &&
              shareBrands?.selected_comp_brand_ids?.length
            ) {
              brandList = shareBrands?.selected_comp_brand_ids?.map((b) => {
                b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
                return b;
              });
            }
          }
          let uniqueBrandList = getUniqueBrandList(brandList);
          setBrandList([...uniqueBrandList]);
        }
      }
    } else {
      let index = getPaneIndex(panes, activeKey);
      let global_brand =
        panes?.[index]?.brands && panes?.[index]?.brands?.columns?.length
          ? panes?.[index]?.brands && panes?.[index]?.brands?.columns
          : panes?.[index]?.brands && panes?.[index]?.brands?.length
          ? panes?.[index]?.brands && panes?.[index]?.brands
          : selectLogicalBrandValue?.["global_dashboard"]?.data?.columns?.length
          ? selectLogicalBrandValue?.["global_dashboard"]?.data?.columns
          : selectLogicalBrandValue?.["global_dashboard"]?.data?.length
          ? selectLogicalBrandValue?.["global_dashboard"]?.data
          : null;

      let sec =
        section_index >= 0 && panes?.[index]?.sections
          ? panes?.[index]?.sections?.[section_index]
          : panes?.[index]?.section?.[0];
      let secLockedOnBrand =
        (sec?.is_locked &&
          sec?.brands?.length > 0 &&
          (sec?.brands?.[0]?.columns?.length > 0
            ? !sec?.brands?.[0]?.columns?.[0]?.competitor
            : !sec?.brands?.[0]?.competitor)) ||
        (sec?.is_locked &&
          (sec?.brand_groups?.length > 0 || sec?.brand_ids?.length > 0));
      let comBrandtypeExists =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? true
          : false;
      sectionComprtitorBrandType =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? sec?.comp_brand_type
          : null;
      let section_brands =
        section_index >= 0
          ? panes[index]?.sections &&
            panes[index]?.sections[section_index] &&
            panes[index]?.sections[section_index]?.brand_ids
          : [null, undefined]?.includes(section_index) &&
            panes[index]?.section &&
            panes[index]?.section[0]
          ? panes[index]?.section[0]?.brand_ids
          : null;
      let section_logical_brands =
        section_index >= 0
          ? panes[index]?.sections &&
            panes[index]?.sections[section_index] &&
            panes[index]?.sections[section_index]?.brand_groups
          : !section_index && panes[index]?.section && panes[index]?.section[0]
          ? panes[index]?.section[0]?.brand_groups
          : null;
      let finalBrand_list = getBrands(
        brandlogicalgroup,
        section_brands,
        Allbrands,
        section_logical_brands
      );

      let sectionBrand =
        finalBrand_list?.columns?.length > 0 ? finalBrand_list?.columns : null;

      selectedBrands =
        secLockedOnBrand && !comBrandtypeExists ? sectionBrand : global_brand;
      sectionComprtitorBrandTypeExists =
        !secLockedOnBrand && comBrandtypeExists;
    }
    if (!shareTemplateData) {
      // for normal brand
      if (
        selectedBrands &&
        !selectedBrands?.[0]?.group &&
        !selectedBrands?.[0]?.competitor
      ) {
        let brandList = [];
        if (Array.isArray(selectedBrands) && selectedBrands?.length) {
          brandList = selectedBrands?.map((b) => {
            b.brand_id = b?.brand_id ? b?.brand_id : b?.name;
            return b;
          });
          setBrandList([...brandList]);
        }
      } else if (selectedBrands && selectedBrands?.[0]?.group) {
        // for logical brand
        let filterBrandLogicalGroup = [];
        Array.isArray(selectedBrands) &&
          selectedBrands?.forEach((sB) => {
            brandlogicalgroup?.forEach((el) => {
              if (
                String(el?.brand_group_name)?.trim()?.toLowerCase() ===
                String(sB?.brand_group_name)?.trim()?.toLowerCase()
              ) {
                filterBrandLogicalGroup = [
                  ...filterBrandLogicalGroup,
                  { ...el },
                ];
              }
            });
          });
        let brandList = [];
        filterBrandLogicalGroup?.map((bl) => {
          brandList = Array.isArray(bl?.brand_list)
            ? [...brandList, ...bl?.brand_list]
            : [...brandList];
        });
        let uniqueBrandList = getUniqueBrandList(brandList);
        setBrandList([...uniqueBrandList]);
      } else if (
        selectedBrands &&
        selectedBrands?.[0]?.competitor // for compititor brand
      ) {
        let brandList = [];
        let newl = [];
        if (!sectionComprtitorBrandTypeExists) {
          brandList.push({
            brand_id: selectedBrands?.[0]?.brand_id
              ? selectedBrands?.[0]?.brand_id
              : selectedBrands?.[0]?.name,
            brand_name: selectedBrands?.[0]?.brand_name,
            brand_friendly_name: selectedBrands?.[0]?.brand_friendly_name,
          });
          newl = selectedBrands?.[0]?.competitorList;
          brandList = [...brandList, ...newl];
        } else if (sectionComprtitorBrandType === false) {
          brandList.push({
            brand_id: selectedBrands?.[0]?.brand_id
              ? selectedBrands?.[0]?.brand_id
              : selectedBrands?.[0]?.name,
            brand_name: selectedBrands?.[0]?.brand_name,
            brand_friendly_name: selectedBrands?.[0]?.brand_friendly_name,
          });
        } else if (sectionComprtitorBrandType === true) {
          newl = selectedBrands?.[0]?.competitorList;
          brandList = [...brandList, ...newl];
        }
        let uniqueBrandList = getUniqueBrandList(brandList);
        setBrandList([...uniqueBrandList]);
      }
    }
  }, [screen, shareBrands]);

  useEffect(() => {
    if (
      authParams?.screen_id === "000-000-558" ||
      (authParams?.screen_id === "000-000-550" &&
        screen?.settings?.is_competitor)
    ) {
      dispatch(setStreamScreenBrand(selectedBrand));
    }
  }, [selectedBrand]);
  const handleChangeBrand = (
    value,
    widgetData,
    section_index,
    widget_index
  ) => {
    const brand =
      value === "ALL" ? null : brandList?.find((el) => el?.brand_id === value);
    setSelectedBrand(brand);
    let widgetSingleBrandFilter = brand;
    let index = getPaneIndex(panes, activeKey);
    let pathName = getWindowLocationPath()?.toLowerCase();

    if (authParams?.screen_id === "000-000-557") {
      let selectedBrand = [widgetSingleBrandFilter];
      // console.log("selectedBrand", selectedBrand);
      dispatch(setStreamScreenBrand(selectedBrand));
    } else if (pathName === "CommandCenter"?.toLowerCase()) {
      if (screen?.screen_id === "000-000-558") {
        if (section_index >= 0 && screen?.sections) {
          // sections case
        } else if (screen?.section) {
          // only widgets case
        } else if (Array.isArray(screen?.widgets) && screen?.widgets?.length) {
          let selectedBrands = [];
          screen?.widgets?.forEach((wid, wid_index) => {
            if (wid?.widgetSingleBrandFilter) {
              selectedBrands.push(
                widget_index === wid_index
                  ? widgetSingleBrandFilter
                  : wid?.widgetSingleBrandFilter
              );
            }
          });
          if (selectedBrands?.length > 0) {
            let selectedNormalBrand = getBrands(
              brandlogicalgroup,
              selectedBrands,
              Allbrands,
              null
            );
            let selectedScreenBrand = selectedNormalBrand
              ? selectedNormalBrand?.columns
                ? selectedNormalBrand
                : {
                    columns: selectedNormalBrand,
                    attribute: "BrandID",
                    type: "varchar",
                  }
              : null;
            dispatch(setBrandsInScreen(selectedScreenBrand));
            dispatch(
              setClearAllScreenWidgetGraphData(
                ["000-100-971", "000-100-972"],
                true
              )
            );
          }
        }
      }
      let updatedPropObj = [
        {
          prop_name: "com_brand_ids",
          prop_value: [widgetSingleBrandFilter],
        },
        {
          prop_name: "widgetSingleBrandFilter",
          prop_value: widgetSingleBrandFilter,
        },
      ];
      dispatch(
        updateScreenWidgetPropdataWithClearGraphData(
          section_index >= 0 ? section_index : null,
          widget_index,
          updatedPropObj
        )
      );
    } else if (
      pathName === "edit-dashboard" ||
      pathName === "create-dashboard"
    ) {
      // edit and create
      if (widgetData) {
        let updatedSection = [...Section];
        if (section_index >= 0) {
          updatedSection[section_index].data[
            widget_index
          ].widgetSingleBrandFilter = widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updatedSection[section_index].data[widget_index].persist_graphdata =
              null;
          }
          if (widgetData?.deep_dive_on) {
            updatedSection[section_index].data[widget_index].deep_dive_on =
              null;
          }
          if (widgetData?.graphData) {
            updatedSection[section_index].data[widget_index].graphData = null;
          }
          if (widgetData?.data) {
            updatedSection[section_index].data[widget_index].data = null;
          }
        } else {
          updatedSection[0].data[widget_index].widgetSingleBrandFilter =
            widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updatedSection[0].data[widget_index].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatedSection[0].data[widget_index].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updatedSection[0].data[widget_index].graphData = null;
          }
          if (widgetData?.data) {
            updatedSection[0].data[widget_index].data = null;
          }
        }
        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    } else if (shareTemplateData) {
      // share dashboard

      if (widgetData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].widgetSingleBrandFilter = widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].widgetSingleBrandFilter = widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      // view dashboard

      if (widgetData) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].widgetSingleBrandFilter = widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          updatePanes[index].section[0].widgets[
            widget_index
          ].widgetSingleBrandFilter = widgetSingleBrandFilter;
          if (widgetData?.persist_graphdata) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
              null;
          }

          if (widgetData?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
    selectRef?.current?.blur();
  };

  const handleDropdownVisibleChange = (open) => {
    if (!open) {
      selectRef?.current?.blur();
    }
  };
  // console.log("screen?.stream_screen_brand", screen?.stream_screen_brand);
  return (
    <>
      {(brandList && Array.isArray(brandList) && brandList?.length > 1) ||
      (getWindowLocationPath()?.toLowerCase() ===
        "CommandCenter"?.toLowerCase() &&
        brandList &&
        Array.isArray(brandList) &&
        brandList?.length > 0) ? (
        <div className="d-flex align-items-center mr-15">
          <Tooltip
            title={
              personalizationSettingsObj?.isPersonalizationPreviewOpen
                ? "Actions are not allowed while customizing"
                : ""
            }
          >
            <Select
              bordered={false}
              onChange={(e) =>
                handleChangeBrand(e, widgetData, section_index, widget_index)
              }
              ref={selectRef}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              popupClassName={
                authParams?.theme_type === "1"
                  ? "darkTheme SingleBrands__dropdown--list"
                  : "lightTheme SingleBrands__dropdown--list"
              }
              value={
                authParams?.screen_id === "000-000-557" &&
                screen?.stream_screen_brand?.[0]?.brand_id
                  ? screen?.stream_screen_brand?.[0]?.brand_id
                  : widgetData?.widgetSingleBrandFilter?.brand_id
                  ? widgetData?.widgetSingleBrandFilter?.brand_id
                  : "ALL"
              }
              style={{
                width: "100%",
                maxWidth:
                  authParams?.screen_id === "000-000-557" ? "" : "20rem",
              }}
              className={`border-radius-4 SingleBrands__dropdown--popup ${
                inStreamScreenWithFilter
                  ? "SingleBrands__dropdown--inStream"
                  : ""
              }`}
              placeholder={"Select Brands"}
              placement={"bottomRight"}
              dropdownMatchSelectWidth={false}
              showSearch={
                ((authParams?.screen_id === "000-000-550" ||
                  authParams?.screen_id === "000-000-558") &&
                  screenSettings?.is_competitor) ||
                authParams?.screen_id === "000-000-557"
              }
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  ?.toLowerCase()
                  ?.includes(input?.toLowerCase())
              }
              disabled={
                personalizationSettingsObj?.isPersonalizationPreviewOpen
              }
            >
              {authParams?.screen_id === "000-000-557" ||
              ((authParams?.screen_id === "000-000-550" ||
                authParams?.screen_id === "000-000-558") &&
                screenSettings?.is_competitor) ? (
                ""
              ) : (
                <Option
                  value={"ALL"}
                  key={"all"}
                  label={"All"}
                  title={"All"}
                  className="SingleBrands__dropdown--option "
                >
                  <div className="d-flex align-items-center">
                    {/* <Image
                style={{
                  width: "2rem",
                  maxHeight: "2rem",
                  borderRadius: "50%",
                }}
                src={el?.brand_logo}
                fallback={DefaultBrandLogo}
                preview={false}
                //className="border border-color box-shadow"
              /> */}
                    {"All"}
                  </div>
                </Option>
              )}
              {brandList &&
                brandList?.map((el, i) => {
                  return (
                    <Option
                      value={el?.brand_id}
                      key={el?.brand_id}
                      label={el?.brand_friendly_name}
                      title={el?.brand_friendly_name}
                      className="SingleBrands__dropdown--option "
                    >
                      <div className="d-flex align-items-center">
                        {authParams?.screen_id === "000-000-550" ||
                        authParams?.screen_id === "000-000-557" ||
                        authParams?.screen_id === "000-000-558" ? (
                          <Image
                            style={{
                              width: "2rem",
                              maxHeight: "2rem",
                              borderRadius: "50%",
                              marginRight: "0.5rem",
                            }}
                            src={el?.brand_logo}
                            fallback={Default_Brand}
                            preview={false}
                            //className="border border-color box-shadow"
                          />
                        ) : (
                          ""
                        )}
                        <span className="text-ellipsis">
                          {el?.brand_friendly_name}
                        </span>
                      </div>
                    </Option>
                  );
                })}
            </Select>
          </Tooltip>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default React.memo(SingleBrandsDropdown, isEqual);
